<template>
  <div
      v-if="collapsed"
      class="footer__collapsed">
    <img
        src="@/assets/icons/new-ui/left-navbar/expand-arrow.svg"
        width="13px"
        @click="notifyExpand">
  </div>
  <div
      v-else
      class="footer">
    <div class="version">
      v. {{ vars.COMMIT }}
    </div>
    <img
        src="@/assets/icons/new-ui/left-navbar/collapse-arrow.svg"
        width="13px"
        @click="notifyCollapse">
  </div>
</template>

<script>
export default {
  name: "MenuFooter",
  emits: ["collapseNotification"],
  data() {
    return {
      vars: null,
      collapsed: false,
    };
  },
  created() {
    this.vars = process.env;
  },
  methods: {
    notifyCollapse() {
      this.collapsed = true;
      this.$emit("collapseNotification", true);
    },
    notifyExpand() {
      this.collapsed = false;
      this.$emit("collapseNotification", false);
    },
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  bottom: 25px;
  left: 16px;

  font-family: "Equip2" !important;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #6e6e6e;

  width: 200px;
  display: flex;
  justify-content: space-between;
}

.version {
  display: inline-block;
}

.footer__collapsed {
  position: fixed;
  bottom: 25px;
  width: 87px;
  text-align: center;
}
</style>
